import Vue from 'vue';
import Router from 'vue-router';

import Layout from '@/components/Layout/Layout';
import LayoutWide from '@/components/Layout/LayoutWide';
import Login from '@/pages/Login/Login';
import Register from '@/pages/Register/Register';
import ErrorPage from '@/pages/Error/Error';
// Core
import NewPage from '@/pages/New/New';
import NewPlan from '@/pages/New/Plan';
import SubscriptionsPage from '@/pages/Subscriptions/Subscriptions';

import SpellingPage from '@/pages/Spelling/Spelling';
import LayoutIssuesPage from '@/pages/Layout/Issues';
import BrokenImagesPage from '@/pages/Resources/BrokenImages';
import BrokenLinksPage from '@/pages/Resources/BrokenLinks';
import JavascriptPage from '@/pages/Javascript/Javascript';
import VulnerabilitiesPage from '@/pages/Javascript/Vulnerabilities';
import VulnerabilityDetailsPage from '@/pages/Javascript/VulnerabilityDetails';
import LogDetails from '@/pages/Javascript/LogDetails';
import DictionaryPage from '@/pages/Spelling/Dictionary';
import BrokenResourcesPage from '@/pages/Resources/BrokenResources';
import ViewPage from '@/pages/Viewer/Viewer';
import SeoSitemapPage from '@/pages/Seo/Sitemap';
import ExplorePage from '@/pages/Explore/Explore';
import ExplorePageDetails from '@/pages/Explore/PageDetails';
import ExploreLinkDetails from '@/pages/Explore/LinkDetails';
import ExploreImageDetails from '@/pages/Explore/ImageDetails';
import ExploreResourceDetails from '@/pages/Explore/ResourceDetails';
import LinksPage from '@/pages/Explore/Links';

import PerformanceLighthousePage from '@/pages/Performance/Lighthouse';
import PerformancePerformancePage from '@/pages/Performance/Performance';
import PerformanceNetworkSlowPage from '@/pages/Performance/NetworkSlow';
import PerformanceNetworkSizePage from '@/pages/Performance/NetworkSize';
import ChangesPage from '@/pages/Explore/Changes';
import SeoContentPage from '@/pages/Seo/Content';
import SeoCrawlPage from '@/pages/Seo/Crawl';
import SeoMobilePage from '@/pages/Seo/Mobile';
import SeoRedirectsPage from '@/pages/Seo/Redirects';

import AdminApiPage from '@/pages/Admin/Api';
import AdminIntegrationsPage from '@/pages/Admin/Integrations';

// Main
import Dashboard from '@/pages/Dashboard/Dashboard';


// Ui
// import IconsPage from '@/pages/Icons/Icons';
const IconsPage = () => import('@/pages/Icons/Icons');
const AccountsPage = () => import('@/pages/Account/Account');
const WebsitesPage = () => import('@/pages/Account/Websites');
const CommandCenterPage = () => import('@/pages/CommandCenter/CommandCenter');
const CommandCenterUsersPage = () => import('@/pages/CommandCenter/Users');
const CommandCenterUserPage = () => import('@/pages/CommandCenter/User');
const CommandCenterCrawlsPage = () => import('@/pages/CommandCenter/Crawls');
const CommandCenterSpellingPage = () => import('@/pages/CommandCenter/Spelling');
const CommandCenterSpellingValidPage = () => import('@/pages/CommandCenter/SpellingValid');
const CrmPage = () => import('@/pages/Crm/Crm');

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    }
  },
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
    },
    {
      path: '/error',
      name: 'Error',
      component: ErrorPage,
    },
    {
      path: '/:token/view',
      name: 'LayoutWide',
      component: LayoutWide,
      children: [
        {
          path: 'seo/crawl',
          name: 'SeoCrawlPage',
          component: SeoCrawlPage,
        },
        {
          path: ':type',
          name: 'ViewPage',
          component: ViewPage,
        },
        ]
    },
    {
      path: '/:token',
      name: 'Layout',
      component: Layout,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
        },
        {
          path: 'account/account',
          name: 'AccountsPage',
          meta: {customMenu: 'account'},
          component: AccountsPage,
        },
        {
          path: 'new/sites',
          name: 'WebsitesPage',
          meta: {customMenu: 'account'},
          component: WebsitesPage,
        },
        {
          path: 'commandcenter',
          name: 'CommandCenterPage',
          component: CommandCenterPage,
        },
        {
          path: 'commandcenter/users',
          name: 'CommandCenterUsersPage',
          component: CommandCenterUsersPage,
        },
        {
          path: 'commandcenter/user/:userid',
          name: 'CommandCenterUserPage',
          component: CommandCenterUserPage,
        },
        {
          path: 'commandcenter/crawls',
          name: 'CommandCenterCrawlsPage',
          component: CommandCenterCrawlsPage,
        },
        {
          path: 'crm',
          name: 'CrmPage',
          component: CrmPage,
        },
        {
          path: 'commandcenter/spelling',
          name: 'CommandCenterSpellingPage',
          component: CommandCenterSpellingPage,
        },
        {
          path: 'commandcenter/spelling/valid',
          name: 'CommandCenterSpellingValidPage',
          component: CommandCenterSpellingValidPage,
        },
        {
          path: 'explore/pages',
          name: 'ExplorePage',
          component: ExplorePage,
        },
        {
          path: 'explore/pages/details',
          name: 'ExplorePageDetails',
          component: ExplorePageDetails,
        },
        {
          path: 'explore/links/details',
          name: 'ExploreLinkDetails',
          component: ExploreLinkDetails,
        },
        {
          path: 'explore/image/details',
          name: 'ExploreImageDetails',
          component: ExploreImageDetails,
        },
        {
          path: 'explore/resource/details',
          name: 'ExploreResourceDetails',
          component: ExploreResourceDetails,
        },
        {
          path: 'seo/sitemap',
          name: 'SeoSitemapPage',
          component: SeoSitemapPage,
        },
        {
          path: 'explore/links',
          name: 'LinksPage',
          component: LinksPage,
        },
        {
          path: 'new/site',
          name: 'NewPage',
          meta: {customMenu: 'account'},
          component: NewPage,
        },
        {
          path: 'new/plan',
          name: 'NewPlan',
          component: NewPlan,
        },
        {
          path: 'subscriptions',
          name: 'SubscriptionsPage',
          component: SubscriptionsPage,
        },
        {
          path: 'components/icons',
          name: 'IconsPage',
          component: IconsPage,
        },
        {
          path: 'resources/images',
          name: 'BrokenImagesPage',
          component: BrokenImagesPage,
        },
        {
          path: 'layout/issues/:device',
          name: 'LayoutIssuesPage',
          component: LayoutIssuesPage,
        },
        {
          path: 'explore/changes',
          name: 'ChangesPage',
          component: ChangesPage,
        },
        {
          path: 'performance/lighthouse',
          name: 'PerformanceLighthousePage',
          component: PerformanceLighthousePage,
        },
        {
          path: 'performance/performance',
          name: 'PerformancePerformancePage',
          component: PerformancePerformancePage,
        },
        {
          path: 'performance/network',
          name: 'PerformanceNetworkSlowPage',
          component: PerformanceNetworkSlowPage,
        },
        {
          path: 'performance/size',
          name: 'PerformanceNetworkSizePage',
          component: PerformanceNetworkSizePage,
        },
        {
          path: 'seo/content',
          name: 'SeoContentPage',
          component: SeoContentPage,
        },
        {
          path: 'seo/mobile',
          name: 'SeoMobilePage',
          component: SeoMobilePage,
        },
        {
          path: 'seo/redirects',
          name: 'SeoRedirectsPage',
          component: SeoRedirectsPage,
        },
        {
          path: 'spelling/issues',
          name: 'SpellingPage',
          component: SpellingPage,
        },
        {
          path: 'spelling/dictionary',
          name: 'DictionaryPage',
          component: DictionaryPage,
        },
        {
          path: 'javascript/logs',
          name: 'JavascriptPage',
          component: JavascriptPage,
        },
        {
          path: 'javascript/logs/details',
          name: 'LogDetails',
          component: LogDetails,
        },
        {
          path: 'javascript/vulnerabilities',
          name: 'VulnerabilitiesPage',
          component: VulnerabilitiesPage,
        },
        {
          path: 'javascript/vulnerabilities/details',
          name: 'VulnerabilityDetailsPage',
          component: VulnerabilityDetailsPage,
        },
        {
          path: 'resources/links',
          name: 'BrokenLinksPage',
          component: BrokenLinksPage,
        },
        {
          path: 'resources/resources',
          name: 'BrokenResourcesPage',
          component: BrokenResourcesPage,
        },
        {
          path: 'admin/api',
          name: 'AdminApiPage',
          component: AdminApiPage,
        },
        {
          path: 'admin/integrations',
          name: 'AdminIntegrationsPage',
          component: AdminIntegrationsPage,
        },
        {
          path: 'admin/integrations/:integration',
          name: 'AdminIntegrationsIntegrationPage',
          component: AdminIntegrationsPage,
        },
      ],
    },
  ],
});
